import { createQueryFn } from '@oneview/redux/utils';
import {
    MiddlewarePersistWatchlistDto,
    MiddlewareWatchlistEntryDto,
    MiddlewareWatchlistEntryDtoTypeEnum,
} from '@orbis-systems/orbis-api-clients/middleware';
import { Quote } from '@orbis-systems/orbis-api-middleware';
import { api } from './baseApi';
import { DataTags } from './dataTags';

export const formatWatchlistEntry = (quote: Quote): MiddlewareWatchlistEntryDto => {
    let type = MiddlewareWatchlistEntryDtoTypeEnum.Equity;

    if (quote.option) {
        type = MiddlewareWatchlistEntryDtoTypeEnum.Option;
    }
    if (quote.bond) {
        type = MiddlewareWatchlistEntryDtoTypeEnum.Bond;
    }
    if (quote.mutualFund) {
        type = MiddlewareWatchlistEntryDtoTypeEnum.MutualFund;
    }
    if (quote.crypto) {
        type = MiddlewareWatchlistEntryDtoTypeEnum.Crypto;
    }

    return {
        symbol: quote.symbol,
        type,
    };
};

export const watchlistApi = api.injectEndpoints({
    endpoints: (build) => ({
        getWatchlists: build.query({
            queryFn: createQueryFn(async (_: void, { extra: api }) => api.orbisMiddleware.watchlist.getAllWatchlists()),
            providesTags: [DataTags.GetWatchlists],
        }),
        createWatchlist: build.mutation({
            queryFn: createQueryFn(
                async (watchlist, { extra: api }) => api.orbisMiddleware.watchlist.createWatchlist(watchlist),
                { pendingMessage: 'Creating watchlist…' },
            ),
            invalidatesTags: [DataTags.GetWatchlists],
        }),
        updateWatchlist: build.mutation({
            queryFn: createQueryFn(
                async (watchlist: MiddlewarePersistWatchlistDto, { extra: api }) =>
                    api.orbisMiddleware.watchlist.updateWatchlist(watchlist.id, watchlist),
                { pendingMessage: 'Updating watchlist…' },
            ),
            invalidatesTags: [DataTags.GetWatchlists],
        }),
        deleteWatchlist: build.mutation({
            queryFn: createQueryFn(
                async (id: number, { extra: api }) => api.orbisMiddleware.watchlist.deleteWatchlist(id),
                {
                    pendingMessage: 'Deleting watchlist…',
                },
            ),
            invalidatesTags: [DataTags.GetWatchlists],
        }),
    }),
});

export const {
    useGetWatchlistsQuery,
    useCreateWatchlistMutation,
    useUpdateWatchlistMutation,
    useDeleteWatchlistMutation,
} = watchlistApi;
